import styled from "styled-components";

export const Portfolio = styled.div`
  .gallery-link {
    cursor: pointer;
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    -moz-transition: opacity 0.3s;
    background: inherit;
    height: 0.5vh;
  }

  .gallery-link:hover {
    opacity: 0.7;
  }

  .gallery-link-label {
    text-align: center;
    font-weight: 500;
    color: #444444;
    font-size: 1.5em;
  }

  /* centered columns styles */
  .row-centered {
    text-align: center;
  }

  .col-centered {
    display: inline-block;
    float: none;
    /* reset the text-align */
    text-align: left;
    /* inline-block space fix */
    margin-right: -4px;
    text-align: center;
  }

  .image {
    padding-bottom: 80%;
    width: 95%;
    margin: 1.66%;
    background-size: cover;
    border-radius: 3px;
    background-position: center center;
    aspect-ratio: 4/5;
  }

  .rect-img-container {
    position: relative;
  }

  .rect-img-container::after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }

  .rect-img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .tight-cols > [class*="col-"] {
    padding-left: 0px;
    padding-right: 0px;
  }
`;
